import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from 'axios'
import { useAuthStore } from '@/auth/auth'

export const ApiSup = defineStore('ApiSup', () => {


  const postSupport = async (url,body) => {
    const authStore = useAuthStore()
    // (body + '---' + `${import.meta.env.VITE_HOST_API}/` + url)
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_HOST_API}/` + url,
        body,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authStore.token}`,
          }
        }
      )
      return response.data
    } catch (error) {
      // console.error('Error posting to events API:', error)
      return error
      // throw error
    }
  }

const getSupport = async (url) => {
  const authStore = useAuthStore()
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_HOST_API}/` + url,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authStore.token}`,
        }
      }
    )

    return response.data
  } catch (error) {
    console.error('Error fetching events:', error)
    return error
  }
}

const putSupport = async (url, data) => {
  const authStore = useAuthStore()

  try {
    const response = await axios.put(
      `${import.meta.env.VITE_HOST_API}/` + url,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authStore.token}`,
        }
      }
    )
    return response.data.status
  } catch (error) {
    console.error('Error updating event:', error)
    throw error
  }
}

const deleteSupport = async (url) => {
  const authStore = useAuthStore()
  try {
    const response = await axios.delete(
      `${import.meta.env.VITE_HOST_API}/` + url,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authStore.token}`,
        }
      }
    )
    return response.data.status
  } catch (error) {
    console.error('Error updating event:', error)
    throw error
  }
}

  return {
    putSupport,
    getSupport,
    postSupport,
    deleteSupport
  }
})
